import { REGEX_PHONE_NUMBER } from "constants/common/common";
import * as yup from "yup";

export const profileValidationSchema = yup.object().shape({
  fullname: yup
    .string()
    .min(2, "Họ và tên phải có ít nhất 2 ký tự")
    .required("Vui lòng nhập họ và tên"),
  phone: yup
    .string()
    .matches(REGEX_PHONE_NUMBER, "Số điện thoại không hợp lệ")
    .nullable()
    .optional(),
});
